export const type = 'form.timePicker';
